import { FC } from "react";

import Icon from "apps/website/components/base/Icon/Icon";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import { iconSvgMap } from "apps/website/components/base/Icon/Icon.map";

const iconMap = {
  tickInverted: iconSvgMap.tickInverted,
};

type TIconName = keyof typeof iconMap;

export interface ITextFooterProps {
  text: string;
  icon?: TIconName;
}

export interface ITextFooter {
  type: "text";
  props: ITextFooterProps;
}

export type TFooterType = ITextFooter;

const isTextFooter = (footer: TFooterType): footer is ITextFooter => footer.type === "text";

export const FooterRenderer: FC<{ footer: TFooterType }> = ({ footer }) => {
  if (isTextFooter(footer)) {
    return (
      <>
        <Spacer size="md" />
        <div className="flex items-center justify-center gap-2">
          { footer.props.icon && (
            <Icon icon={footer.props.icon} size="xsmall" />
          ) }
          <TextBody size={3}>{ footer.props.text }</TextBody>
        </div>
      </>
    );
  }

  return null;
};
